import React from 'react'
import cx from 'classnames'
import styled from 'styled-components'
import { Row, Col, Icon } from 'antd'

type PropTypes = {
  className?: string
  style?: React.CSSProperties
  wrapperClassName?: string
  wrapperStyle?: React.CSSProperties
}

const Wrapper = styled.div`
  .ant-spin {
    &--inner {
      margin: 0 auto;
    }
  }
`

export default React.memo(function Loading({
  className,
  style,
  wrapperClassName,
  wrapperStyle,
  ...props
}: PropTypes) {
  return (
    <Wrapper style={wrapperStyle} className={cx('bg-greyF9', wrapperClassName)}>
      <Row type="flex" justify="center" className={className}>
        <Col className="ant-spin--inner">
          <Icon type="loading-3-quarters" spin theme="outlined" style={style} />
        </Col>
      </Row>
    </Wrapper>
  )
})
